import { createSelector } from 'reselect'
import { groupBy, sum } from 'lib/array/arrayUtils'
import getMerchandiseItemViews from '../itemViews/getMerchandiseItemViews'
import { getMerchandiseVariantOptionText } from 'components/Merchandise/merchandiseUtils'

const getMerchandiseBreakdownView = createSelector(
  (state: App.State) => getMerchandiseItemViews(state),
  (itemView): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    const ticketCount = itemView.data.length
    if (ticketCount === 0) {
      return {
        hasRequiredData: true,
        data: [],
      }
    }

    const uniqueVariants = groupBy(itemView.data, data => data.variant.id)

    return {
      data: uniqueVariants.values().map((views): App.Checkout.PriceBreakdownView => ({
        title: views[0].title,
        alwaysShowItemPrice: true,
        additionalInfoText: [
          getMerchandiseVariantOptionText(views[0].variant),
          `Qty: ${views.length}`
        ],
        price: sum(views, view => view.totals.price),
        memberPrice: 0,
        itemsAlwaysVisible: true,
        items: [],
      })).toArray(),
      hasRequiredData: itemView.hasRequiredData,
    }
  },
)

export default getMerchandiseBreakdownView
